import React from 'react';
import PropTypes from 'prop-types';
import cx from 'classnames';

import style from './VisuallyHidden.less';

/**
 * Wraps its children with a `<span>` element (override with `as`). Contents
 * will be hidden from sighted users, but accessible for screenreader users.
 *
 * @param {object} props
 * @param {ReactNode} props.as The wrapper node. Default is 'span'.
 * @param {string} props.className Extra CSS classes to add.
 *
 * @deprecated If project is using the design system's components, utilize the wink-visually-hidden classname instead.
 *
 */
function VisuallyHidden({ as: Component = 'span', className, ...props }) {
  return (
    <Component
      // From: https://www.scottohara.me/blog/2019/05/22/contextual-images-svgs-and-a11y.html
      // When used within an interactive element, multiple virtual cursor focus
      // stops will be created in some screen readers. Adding
      // role="presentation" will help make sure the virtual cursor does not
      // stop multiple times when using the Up or Down arrow keys to navigate
      // to or through an interactive element.
      role="presentation"
      className={cx(style.visuallyHidden, className)}
      {...props}
    />
  );
}

VisuallyHidden.propTypes = {
  as: PropTypes.any,
  className: PropTypes.string,
};

export default VisuallyHidden;
